import { SITE_URL } from "@/lib/site";

export const MAIN_SITE = "https://dogdayrenovations.com";

export type BlogPost = {
  slug: string;
  title: string;
  seoTitle: string;
  description: string;
  excerpt: string;
  category: string;
  byline: string;
  publishedAt: string; // ISO with offset
  readingMinutes: number;
};

export const BATHROOM_POST: BlogPost = {
  slug: "planning-bathroom-remodel-winston-salem",
  title: "Planning a Bathroom Remodel in Winston-Salem: Where to Start",
  seoTitle: "Bathroom Remodel Planning in Winston-Salem | Dog Day",
  description:
    "Planning a bathroom remodel in Winston-Salem? Explore layout, storage and finish decisions, use our priority checklist, and discuss your project with Dog Day.",
  excerpt:
    "Start your bathroom remodel with a clear plan. Explore layout, storage, finishes and everyday needs, then use a simple checklist to organize your priorities.",
  category: "Bathroom Remodeling",
  byline: "Dog Day Renovations",
  publishedAt: "2026-10-16T10:00:00-04:00",
  readingMinutes: 7,
};

export const POSTS: BlogPost[] = [BATHROOM_POST];

export const postUrl = (p: BlogPost) => `${SITE_URL}/blog/${p.slug}`;

/** A post is live only once its release time has passed. */
export const isPublished = (p: BlogPost, now = Date.now()) =>
  new Date(p.publishedAt).getTime() <= now;

export const publishedPosts = (now = Date.now()) => POSTS.filter((p) => isPublished(p, now));

export const formatDate = (iso: string) =>
  new Date(iso).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "America/New_York",
  });

export function track(event: string, params: Record<string, string>) {
  const g = (window as unknown as { gtag?: (...a: unknown[]) => void }).gtag;
  g?.("event", event, params);
}
